module.exports = __webpack_public_path__ + "static/media/LogoGiftoria.3c02f5e4.png";